/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `tcf_canada` - TCF Canada
* `ielts_general` - IELTS General Training
* `tef_canada` - TEF Canada
* `goethe` - Goethe-Zertifikat (allemand)
 */
export type ExamEnum = typeof ExamEnum[keyof typeof ExamEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExamEnum = {
  tcf_canada: 'tcf_canada',
  ielts_general: 'ielts_general',
  tef_canada: 'tef_canada',
  goethe: 'goethe',
} as const;
